export default "__VITE_ASSET__38e4030a__"